import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FooterDTO } from '../../../shared/footer-dto';

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  footer: FooterDTO[] = []
  footerSubject: Subject<FooterDTO[]> = new Subject<FooterDTO[]>();

  constructor(private http: HttpClient) {
    this.footerSubject.subscribe(footer => this.footer = footer)
    this.getFooter()
  }

  getFooter(isWholesale?: boolean) {
    this.http.get<FooterDTO[]>(`/api/footer${isWholesale ? '?is_wholesale=1' : ''}`)
    .subscribe(footer => this.footerSubject.next(footer))
  }
}
